module.exports = "<button type=\"button\" class=\"estilo-botao\" (click)=\"editarCurriculo()\"><i class=\"fa fa-edit fa-2x\"></i></button>\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/administracao/curriculo/botaoGridCurriculo.component.html
// module id = ./src/app/pages/administracao/curriculo/botaoGridCurriculo.component.html
// module chunks = main